import { useEffect, useLayoutEffect } from 'react';

import { SUPPORT_MESSAGE_WS_EVENT } from '@app/api/Support/const';
import {
  addWsEventListener,
  createWSConnection,
} from '@app/utils/createWSConnection';

export interface UseSupportChatEffectsProps {
  isOpen: boolean;
  syncMessagesScroll(): void;
  resetChatState(): void;
  handleClosedChatMessageEvent(raw: unknown): void;
  markMessagesAsRead(): void;
}

export const useSupportChatEffects = ({
  isOpen,
  syncMessagesScroll,
  resetChatState,
  handleClosedChatMessageEvent,
  markMessagesAsRead,
}: UseSupportChatEffectsProps): void => {
  // useLayoutEffect — чтобы позиция ленты менялась до отрисовки, без скачка
  useLayoutEffect(() => {
    syncMessagesScroll();
  }, [syncMessagesScroll]);

  useLayoutEffect(() => {
    if (!isOpen) {
      resetChatState();
    }
  }, [isOpen, resetChatState]);

  useEffect(() => {
    if (isOpen) {
      markMessagesAsRead();
    }
  }, [isOpen, markMessagesAsRead]);

  // При открытом окне OnSupportMessage слушает кеш переписки (см.
  // onCacheEntryAdded в src/api/Support), а пока окно закрыто — только
  // считаем непрочитанные ответы для бейджа на кнопке.
  useEffect(() => {
    if (isOpen) return;

    let isEffectActive = true;
    let removeListener: (() => void) | undefined;

    // addWsEventListener вешает обработчик на хаб, только если соединение
    // уже создано, — поэтому сначала дожидаемся его.
    void createWSConnection(() => {
      if (!isEffectActive) return;

      removeListener = addWsEventListener(
        SUPPORT_MESSAGE_WS_EVENT,
        handleClosedChatMessageEvent
      );
    });

    return () => {
      isEffectActive = false;
      removeListener?.();
    };
  }, [handleClosedChatMessageEvent, isOpen]);
};
